<template>
  <v-container class="A4 mb-3" id="printMe">
    <span v-html="styleText"></span>

    <v-row class="d-flex justify-end my-header">
      <v-btn @click="goBack" class="primary my-btn my-1">
        <i class="mdi mdi-arrow-left-bold"></i>返回
      </v-btn>
      <v-btn v-print="printObj" class="primary my-btn my-1 ml-1 mr-11">
        <i class="mdi mdi-printer"></i>打印
      </v-btn>
    </v-row>

    <h1 class="head-1" style="text-align:center;">
      安置结算同意书
    </h1>
    <v-row style="width:100%;display: inline-flex;margin-left:-5px !important;margin-top:30px">

      <p class="note-header " style="line-height:55px">
        <span style="padding-left:2em;"></span>
        <span class="data-text"> {{ details.village }} </span>村
        <span class="data-text"> {{ details.customer }} </span><span>搬迁户，现结算第{{ surplus }}套安置房（视作第<span class="data-text">
            {{ details.bill_seq }} </span>套结算）位于</span>
        <span class="data-text"> {{ details.garden_name }} </span>
        <span class="data-text"> {{ details.building_name }} </span>幢
        <span class="data-text"> {{ details.unit_name }} </span>梯
        <span class="data-text"> {{ details.house_number }} </span>室，安置房面积
        <span class="data-text" v-if="details.area > 0"> {{ details.area }} </span><span class="data-text" v-else> /
        </span>㎡，
        其中标准面积（<span> {{ parseInt(details.population_price) }} 元</span>/㎡）
        <span class="data-text" v-if="details.population_area > 0"> {{ details.population_area }} </span><span
          class="data-text" v-else> / </span>㎡，
        置换面积（<span v-if="details.special_area > 0"> {{ parseInt(details.special_price) }} 元</span> <span v-else> {{
          parseInt(details.property_price) }} 元</span>/㎡）
        <span class="data-text" v-if="details.special_area > 0"> {{ details.special_area }} </span><span class="data-text"
          v-else-if="details.property_area > 0"> {{ details.property_area }} </span><span class="data-text" v-else> /
        </span>㎡，
        市场优惠价面积（<span> {{ parseInt(details.extend_price) }} 元</span>/㎡）
        <span class="data-text" v-if="details.extend_area > 0"> {{ details.extend_area }} </span><span class="data-text"
          v-else> / </span>㎡，
        超20㎡以上面积（<span> {{ parseInt(details.market_discount_price) }} 元</span>/㎡）
        <span class="data-text" v-if="details.market_discount_area > 0"> {{ details.market_discount_area }} </span><span
          class="data-text" v-else> / </span>㎡。房屋维修基金由开发商按相关规定收取。
      </p>
      <v-row class="note-header indent">
        <span>本户及本户经办人员均同意该套房由拆迁公司按照价格结算。</span>
      </v-row>
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">搬迁经办人（签名捺印）：<input type="text" name="name"
            class="my-input150" /></span>

      </v-row>
      <v-row class="note-header indent" style="width:100%">
        <span style="width:100%;text-align:right;">{{
          $moment(details.delivery_time).utc().format("YYYY-MM-DD HH:mm:ss") }}</span>

      </v-row>
    </v-row>


  </v-container>
</template>

<script>
import { fetchContract } from "@/api/contracts";

export default {
  name: "Bill Print",
  components: {},

  filters: {},
  data() {
    return {
      styleText: '<style type="text/css">\n' + '  @page { size: portrait; }\n' + '</style>',
      src: "hetong.png",
      seq: "",
      user_name: this.$store.getters.name,
      company: this.$store.getters.company,
      details: null,
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      sub_fee: 0,
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      },
      icons: {
        sub_bike: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        sub_car: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        bike: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        },
        car: {
          status: false,
          icon: "mdi-checkbox-blank-circle-outline"
        }

      },

    }
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getBill(this.$route.params.id);

    this.dt_now = Date.now();
    this.seq = this.$route.params.seq;
    console.log(this.$route.params.surplus)
    this.surplus = this.numberToString(this.$route.params.seq);
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getBill(id) {
      this.listLoading = true;
      fetchContract(id).then(response => {
        this.details = response.data;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    numberToString(number) {
      let zhArray = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']; // 数字对应中文
      return zhArray[number];
    }
  }
};
</script>

<style scoped>
body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);

}

.A4 {
  background: rgb(255, 253, 253);
  /* background-image: url(/../assets/hetong.png); */
  /* width: 21cm;
  height: 29.7cm; */
  width: 1000px;
  height: 794px;
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
  font-family: serif;
  color: #000;
}

.head-1 {
  margin-top: 0;
  /* padding: 0 0 20px 0; */
  font-weight: 600;
  font-size: 30pt;
  text-align: center;
  width: 100%;
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(3, 54, 192);
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 80px 4px 80px;
  font-size: 25pt;
}

.indent {
  text-indent: 2em
}

.my-input150 {
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 150px;
  text-align: center;
}

.line {
  line-height: 1.5;
}

.note-footer {
  padding: 20px 25px 10px 40px;
}

.data-text {
  border-bottom: 1.5px solid #555555;
  padding: 0 10px 0 10px;
}

.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}

.icon-check {
  color: #000 !important;
  margin-right: -5px;
  font-size: 12px !important;
  height: 0px;
  width: 25px;
}

.theme--dark .v-label {
  color: #000 !important;
}


@page {
  /* size: A4; */
  /* size: portrait; */
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }

  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
}</style>
